import * as React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import type { State as AppState } from 'state';
import { getPortalId } from 'state/selectors/context';
import { getKbSuggestions } from 'state/selectors/portal';
import type { KnowledgeArticle } from 'state/ui/search';
import KbSuggestedArticles from '../kb-suggestions/kb-suggestions';

interface KbSuggestedArticlesWrapperProps {
    kbArticles: KnowledgeArticle[];
}

export const KbSuggestedArticlesWrapper = (props: KbSuggestedArticlesWrapperProps) => {
    const { kbArticles } = props;

    if (!!kbArticles && !isEmpty(kbArticles)) {
        return <KbSuggestedArticles articles={kbArticles} connectedToForm />;
    }
    return null;
};

const ConnectedKbSuggestedArticlesWrapper = connect((state: AppState) => {
    const portalId = getPortalId(state);
    const kbArticles = getKbSuggestions(state, portalId);
    return {
        kbArticles,
    };
})(KbSuggestedArticlesWrapper);

export default ConnectedKbSuggestedArticlesWrapper;
